/* global axios */
import ApiClient from './ApiClient';

// Onboarding no padrão Visor (D64): estado, progresso salvo na conta,
// imóveis do catálogo para conferir e conclusão.
class OnboardingVisorAPI extends ApiClient {
  constructor() {
    super('onboarding_visor', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  save(progress) {
    return axios.patch(this.url, progress);
  }

  properties() {
    return axios.get(`${this.url}/properties`);
  }

  finish() {
    return axios.post(`${this.url}/finish`);
  }
}

export default new OnboardingVisorAPI();
